<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Scale di Valutazione</span>
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <!--   <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="btnAggiungi" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button> -->
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(dataOraCompilazione)="{ item }">
                        <span>{{ formatDateTime(item.createDate) }}</span>
                    </template>
                    <template v-slot:cell(autore)="{ item }">
                        <span>{{ item.createUser }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <print-component :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                        <!--  <b-button size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" @click="onClickStampa(item)">
                            <b-icon icon="printer" />
                        </b-button>-->
                        <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary" @click="onClickVisualizzaScala(item)" title="Visualizza">
                            <font-awesome-icon icon="eye" />
                        </b-button>
                        <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-danger" @click="onClickDeleteScala(item)" title="Elimina">
                            <font-awesome-icon icon="trash" />
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-scale-valutazione-modal-edit-component ref="cmpRsaScaleModalEdit" @afterSave="onAfterSave"></rsa-scale-valutazione-modal-edit-component>
        <b-modal :title="dynamicJsonData.titolo" ref="mdlDynamicForm" size="lg" @shown="onShownDynamicForm" @ok="onOkDynamicForm" scrollable>
            <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="isDynamicFormView"></dynamic-form>
        </b-modal>
        <!--   <b-modal scrollable b-modal ref="mdlScaleValutazioneView" id="mdlScaleValutazioneView" size="xl" style="height: 100%" :title="titoloModale" @ok="onInvia" ok-only></b-modal> -->
        <modal-loading ref="cmpModalLoading"></modal-loading>
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaScaleValutazioneModalEditComponent from "../../components/rsascalevalutazione/RsaScaleValutazioneModalEditComponent.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import DynamicForm from "../../../utility/components/DynamicForm.vue";
import ModalLoading from "../../../../template/components/modal/components/ModalLoading.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaScaleValutazioneModalEditComponent, PrintComponent, DynamicForm, ModalLoading, ModalError },
    props: {
        utente: { type: Object },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsascalevalutazionepaziente",
            pathResourceDynamicForm: "/dynamicform",
            btnAggiungi: false,
            scaleValutazioniPazienteFilter: { idAccettazione: null, tiposcale: null, dataDal: null, dataAl: null },
            idAccettazione: "",
            items: [],
            isDynamicFormView: true,
            dynamicJsonData: {},
            defaultValues: {},
            jsonDataAccettazione: {},
            fields: [
                {
                    label: "Tipo",
                    key: "tipoScale",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Data/Ora Compilazione",
                    key: "dataOraCompilazione",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Punteggio",
                    key: "punteggio",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Autore",
                    key: "autore",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "",
                    key: "action",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(idAccettazione, data) {
            let me = this;
            me.idAccettazione = idAccettazione;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["scaleValutazioniPazienteFilter"]) {
                me.scaleValutazioniPazienteFilter = JSON.parse(sessionStorage["scaleValutazioniPazienteFilter"]);
            }
            me.scaleValutazioniPazienteFilter.idAccettazione = idAccettazione;
            me.jsonDataAccettazione = data;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.scaleValutazioniPazienteFilter.page = me.currentPage;
            me.scaleValutazioniPazienteFilter.forPage = me.perPage;
            this.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResource, me.scaleValutazioniPazienteFilter, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle scale", error.response.data.messaggio ? error.response.data.messaggio : "", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },
        onClickAggiungi() {
            let me = this;
            me.$refs.cmpRsaScaleModalEdit.show(me.idAccettazione);
        },
        onClickVisualizzaScala(item) {
            //let me = this;
            //me.$refs.cmpRsaScaleModalEdit.visualizzaScala(item);
            let me = this;
            me.attivitaSelezionata = item;
            me.loadDinamicFormView(item.idForm);
        },
        loadDinamicFormView(idForm) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + idForm, {}, me.loadDinamicFormViewSuccess, me.loadDinamicFormViewError);
        },
        loadDinamicFormViewSuccess(response) {
            let me = this;
            if (response.data.data.pathModule) {
                me.$refs.cmpModalLoading.close();
                let dynamicJsonData = response.data.data;
                dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
                me.dynamicJsonData = dynamicJsonData;
                let link = process.env.VUE_APP_PATH_API + response.data.data.pathModule + "/attivita/" + me.attivitaSelezionata.idAttivita;
                axios
                    .get(link)
                    .then((response) => {
                        me.defaultValues = response.data.data;
                        me.defaultValues.ospite = me.jsonDataAccettazione.accettazioneAnagrafica.nome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
                        me.defaultValues.educatore = me.utente.firstname + " " + me.utente.lastname;
                        me.defaultValues.numero = me.jsonDataAccettazione.numero;
                        me.defaultValues.dataNascita = me.formatDate(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
                        me.isDynamicFormView = true;
                        me.$refs.mdlDynamicForm.show();
                    })
                    .catch((error) => {
                        let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                        if (!messaggio) {
                            messaggio = error.message;
                        }
                        this.$bvModal
                            .msgBoxOk(messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerBgVariant: "danger",
                                centered: true,
                            })
                            .then((value) => {
                                console.log(value);
                            })
                            .catch(() => {});
                    });
            } else {
                me.$bvModal.msgBoxOk("Path del modulo non configurato", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerBgVariant: "danger",
                    centered: true,
                });
            }
        },
        loadDinamicFormViewError(error) {
            console.log(error);
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
        /*    onClickDeleteScala(id) {
            console.log(id);
        },
 */
        onClickDeleteScala(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Scala",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteScala(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteScala(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .delete(link)
                .then((response) => {
                    me.loadData();
                    me.showModalLoading = false;
                    me.$emit("onDelete", response);
                    me.$bvToast.toast("Eliminazione avvenuta con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore durante l'eliminazione", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        onClickStampa(item) {
            let me = this;
            let path = item.pathModule;
            me.loadDataResources(path + "/printdata/" + item.idAttivita, null, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            let me = this;
            let messaggio = error.response.messaggio ? error.response.messaggio : "Stampa non disponibile";
            me.$refs.cmpModalError.show(messaggio + "#");
        },
        onShownDynamicForm() {
            let me = this;
            me.$refs.cmpDynamicForm.setForm(me.defaultValues);
        },
        onOkDynamicForm() {
            let me = this;
            me.$refs.mdlDynamicForm.hide();
        },
    },
};
</script>

<style></style>
